import styled from 'styled-components';

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export default Item;
